import { ErrorIndicator } from '@components/ErrorIndicator';
import { Layout } from '@components/Layout';
import { Bundle as BundleUi } from '@features/Bundle';
import { OutdatedBundleModal } from '@features/expiredQuotes/OutdatedBundleModal';
import { useOutdatedBundleModal } from '@features/expiredQuotes/useOutdatedBundleModal';
import { Quote } from '@generated/gql/graphql';
import { useBundleBasket } from '@hooks/useBundleBasket';
import { useDetectMidJourneyLogin } from '@hooks/useDetectMidJourneyLogin';
import { usePageStateHandler } from '@hooks/usePageStateHandler';
import { withProfiler } from '@services/sentry/withProfiler';
import {
  BundleBasketData,
  OutdatedBundleModalVariant,
} from '@src/types/bundle';

const PAGE_TITLE = 'Your bundle';

const ErrorWrapper = () => (
  <Layout title={PAGE_TITLE}>
    <ErrorIndicator />
  </Layout>
);

const BundleUnwrapped = () => {
  const {
    error,
    basket,
    loading,
    basketRaw,
    refetch,
    basketData,
    selectedServices,
  } = useBundleBasket({});

  useDetectMidJourneyLogin({ basketData, loading });

  const {
    modalState,
    isLoading: isModalLoading,
    error: modalError,
    handleOnContinue,
  } = useOutdatedBundleModal((basketRaw?.quotes as Quote[]) ?? [], refetch);

  const { isLoading, hasError } = usePageStateHandler({
    loading: isModalLoading || loading,
    hasData: !!basket,
    error: modalError || error,
  });

  if (isLoading) {
    return null;
  }

  if (hasError) {
    return <ErrorWrapper />;
  }

  const { variant, removedProducts } = modalState;

  return (
    <Layout title={PAGE_TITLE}>
      <BundleUi
        basket={basket as BundleBasketData}
        basketData={basketData}
        selectedServices={selectedServices}
      />
      <OutdatedBundleModal
        isOpen={variant !== OutdatedBundleModalVariant.none}
        removedProducts={removedProducts}
        onContinue={handleOnContinue}
      />
    </Layout>
  );
};

const Bundle = withProfiler(BundleUnwrapped);
export { Bundle };
